import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private _hasCommonAccess: boolean = false;
  private _hasAdminAccess: boolean = false;

  constructor() { }

  set hasCommonAccess(hasCommomAcc: boolean){
    this._hasCommonAccess = hasCommomAcc;
  }

  get hasCommonAccess(): boolean{
    return this._hasCommonAccess;
  }

  set hasAdminAccess(hasAdminAcc: boolean){
    this._hasAdminAccess = hasAdminAcc;
  }

  get hasAdminAccess(): boolean{
    return this._hasAdminAccess;
  }
}
